import Typography from "@mui/material/Typography";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import Button from "@mui/material/Button";
import { LoadingListEntityProfile } from "Explore/Components";
import { Empty, Tag } from "antd";
import { useState } from "react";
import useInfinityPagination from "Hooks/useInfinityPagination";
import InfinityPagination from "Explore/Components/Pagination/InfinityPagination";
import LoginRequiredSection from "Explore/Components/LoginRequired";
import { getVenueTopPapersByID } from "Explore/Services/Venue";
import styles from "./VenueTopPapers.module.scss";

const VenueTopPapers = ({ venueId, timeFilter, keywords = [] }) => {
  const [pagination, setPagination] = useState({ page: 1, rowsPerPage: 10 });
  const [showLoginSection, setShowLoginSection] = useState(false);

  const { data, currentMaxPage, hasNextPage, isLoading } =
    useInfinityPagination({
      fetchFunction: getVenueTopPapersByID,
      page: pagination.page,
      filter: {
        venueId,
        time_filter: timeFilter,
        keywords,
      },
      rowsPerPage: pagination.rowsPerPage,
      setPagination,
      errCallback: (e) => {
        if (e?.response?.status === 401) {
          setShowLoginSection(true);
        }
      },
    });

  const currentPageData = data[pagination.page - 1] || [];

  const Publication = ({ publication }) => {
    return (
      <div className={styles["publication"]}>
        <div className={styles["title"]}>
          <span className={styles["paper-title"]}>
            <a href={publication.doi} target="_blank" rel="noreferrer">
              {publication.title}.{" "}
            </a>
          </span>
          <span className={styles["venue"]}>
            <i>{publication.venue} </i>
          </span>
          <span>{publication.year > 0 ? `(${publication.year})` : ""}</span>
        </div>
        <div className={styles["coauthors"]}>
          {publication.coauthors.map((item, index) => {
            return <span key={index}>{item.name}</span>;
          })}
        </div>
        <div className={styles["tags"]}>
          {publication.keywords.map((item, index) => {
            return (
              <Tag
                key={index}
                color="var(--light-blue)"
                style={{ cursor: "pointer", color: "var(--dark-grey)" }}
              >
                {item.id}
              </Tag>
            );
          })}
        </div>
        <div className={styles["action"]}>
          {false && (
            <Button
              style={{
                backgroundColor: "white",
                color: "#b45f06",
                borderRadius: 10,
                height: 25,
                paddingLeft: 0,
                textAlign: "left",
                textTransform: "none",
                marginRight: "10px",
              }}
            >
              <FormatQuoteIcon />
              <Typography align={"left"} style={{ fontSize: 12 }}>
                {publication["num_citations"]}
              </Typography>
            </Button>
          )}
        </div>
      </div>
    );
  };
  return (
    <div className={styles["venue-top-papers"]}>
      <LoadingListEntityProfile
        isLoading={isLoading}
        component={
          currentPageData.length > 0 ? (
            currentPageData.map((item, index) => {
              return <Publication publication={item} key={index} />;
            })
          ) : showLoginSection ? (
            <LoginRequiredSection />
          ) : (
            <Empty description="No paper Found." />
          )
        }
        componentNum={10}
        rows={2}
        avatar={false}
      />
      <InfinityPagination
        style={{ marginTop: "20px" }}
        currentMaxPage={currentMaxPage}
        pagination={pagination}
        setPagination={setPagination}
        hasNextPage={hasNextPage}
        isLoading={isLoading}
        sizeChanger
      />
    </div>
  );
};

export default VenueTopPapers;
